import React from 'react';
import styled from 'styled-components';
// components
import Toolbar from '../toolbar/toolbar';
import PageContent from './pageContent';

const PageLayout = ({ children, className }) => (
  <div className={className}>
    <Toolbar />
    <PageContent>{children}</PageContent>
  </div>
);

export default styled(PageLayout)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
